import { cn } from '@/shared/lib/utils'
import { t } from '@/shared/lib/i18n'

type NoAccessNoticeProps = {
  /** Overrides the default "no permission to perform this action" copy. */
  message?: string
  className?: string
}

/**
 * Muted inline notice shown when a user lacks permission for the actions on screen.
 * Pairs with disabled action controls (e.g. the calendar day-occurrence review actions)
 * so the reason is visible.
 */
export function NoAccessNotice({ message, className }: NoAccessNoticeProps) {
  return (
    <div
      className={cn(
        'rounded border border-muted bg-muted/40 px-3 py-2 text-xs text-muted-foreground',
        className,
      )}
    >
      {message ?? t('common.permissions.noActionAccess')}
    </div>
  )
}
